// Picks the inbox this onboarding run is actually configuring — the one recorded in
// step 1's draft_data.inbox_id. OnboardingProgress#record_detected_inbox! records this
// for every account going forward, including ones that completed step 1 through
// auto-detection rather than the wizard's own connect/select flow, so this should
// always be present in practice.
//
// The fallback below only matters for onboarding_progress rows that predate that
// backend fix. GET /inboxes orders alphabetically by name (order_by_name) — payload[0]
// is NOT "the wizard's inbox" and can be any channel type, so it must never be trusted
// ahead of a WhatsApp-capable one.
const WHATSAPP_CHANNEL_TYPES = ['Channel::Gupshup', 'Channel::Whatsapp'];

export const resolveTargetInbox = (payload, progress) => {
  const chosenId = progress?.draft_data?.step_1?.inbox_id;
  if (chosenId) {
    const chosen = payload.find(inbox => inbox.id === chosenId);
    if (chosen) return chosen;
  }
  return (
    payload.find(inbox =>
      WHATSAPP_CHANNEL_TYPES.includes(inbox.channel_type)
    ) ||
    payload[0] ||
    null
  );
};
